"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _reactDraggable = _interopRequireWildcard(require("react-draggable"));

var _reactFela = require("react-fela");

var _ = require("../..");

var _util = require("../../../util");

var css = _interopRequireWildcard(require("./PnlAnaliticsChart.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const PnlAnaliticsChart = ({
  maxProfit = '0',
  maxLoss = '0',
  maxLossUnlimited,
  maxProfitUnlimited,
  breakEven,
  chartSteps,
  scripName,
  maxProfitText,
  maxLossText,
  unlimitedText,
  breakEvenText,
  takeHomeText,
  ...otherProps
}) => {
  const containerRef = React.useRef(null);
  const fela = (0, _reactFela.useFela)();
  const theme = fela.theme;
  const [gradient, setGradient] = React.useState(49.9);
  const [currentItemIndex, setCurrentItemIndex] = React.useState(0);
  const [fullHeight, setFullHeight] = React.useState(438);
  const chartStepsLength = chartSteps.length;
  const isTwoBreakEvens = breakEven.length === 2;
  const gap = 20;
  const diapason = fullHeight / (chartStepsLength > 9 ? chartStepsLength + 1 : chartStepsLength);
  const numMaxProfit = (0, _util.unformatValue)(maxProfit);
  const numMaxLoss = (0, _util.unformatValue)(maxLoss);

  const handleDrag = (e, {
    y
  }) => {
    const index = Math.round(y / diapason);

    if (index > chartStepsLength - 1) {
      setCurrentItemIndex(chartStepsLength - 1);
    } else {
      setCurrentItemIndex(index);
    }
  };

  const calculateGradient = () => {
    if (maxLossUnlimited || maxProfitUnlimited) {
      setGradient(49.9);
      return;
    }

    const sum = Math.abs(numMaxProfit) + Math.abs(numMaxLoss);
    const green = 100 * Math.abs(numMaxProfit) / sum;
    setGradient(green);
  };

  const checkChartSteps = () => {
    if ((0, _util.unformatValue)(chartSteps[0].payoff) === numMaxProfit && (0, _util.unformatValue)(chartSteps[chartStepsLength - 1].payoff) === numMaxProfit || maxProfitUnlimited) {
      setGradient('profit');
    } else if ((0, _util.unformatValue)(chartSteps[0].payoff) === numMaxLoss && (0, _util.unformatValue)(chartSteps[chartStepsLength - 1].payoff) === numMaxLoss || maxLossUnlimited) {
      setGradient('loss');
    }
  };

  const calculateTopPosition = percentage => fullHeight * percentage / 100;

  const calculateBreakEvenPosition = () => {
    if (gradient > 90) {
      return {
        breakEvenTop: calculateTopPosition(90),
        dividerTop: calculateTopPosition(93.6)
      };
    }

    const topPositionBreakEven = calculateTopPosition(Number(gradient));
    const topPositionDivider = topPositionBreakEven + gap;
    return {
      breakEvenTop: topPositionBreakEven,
      dividerTop: topPositionDivider
    };
  };

  const addRupeeSign = value => {
    const negativeWithRupeeSign = "".concat(value).replace('-', '');
    return (0, _util.unformatValue)(value) < 0 ? "-\u20B9".concat(negativeWithRupeeSign) : "\u20B9".concat(value);
  };

  React.useEffect(() => {
    if (isTwoBreakEvens) {
      checkChartSteps();
    } else {
      calculateGradient();
    }
  }, [isTwoBreakEvens]);
  React.useEffect(() => {
    if (containerRef.current) {
      setFullHeight(containerRef.current.clientHeight);
    }
  }, []);
  const {
    breakEvenTop,
    dividerTop
  } = calculateBreakEvenPosition();
  const maxProfitWithSign = maxProfitUnlimited ? unlimitedText : addRupeeSign(maxProfit);
  const maxLossWithSign = maxLossUnlimited ? unlimitedText : addRupeeSign(maxLoss);
  return (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.container,
    flex: true,
    flexDirection: "column",
    justifyContent: "space-between",
    ref: containerRef
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    padding: [0, 24]
  }, isTwoBreakEvens ? (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.View, {
    css: css.divider,
    cssProps: {
      top: calculateTopPosition(28)
    }
  }), (0, _pragma.createFelaElement)(_.View, {
    css: css.divider,
    cssProps: {
      top: calculateTopPosition(72)
    }
  }), (0, _pragma.createFelaElement)(_.View, {
    css: css.maxAbsoluteBlock,
    flexDirection: "column",
    padding: [0, 24]
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body"
  }, gradient === 'loss' ? maxProfitText : maxLossText), gradient === 'loss' ? (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: "text.positive"
  }, maxProfitWithSign) : (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: "text.negative"
  }, maxLossWithSign))) : (0, _pragma.createFelaElement)(_.View, {
    css: css.divider,
    cssProps: {
      top: dividerTop
    }
  }), (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body"
  }, gradient === 'loss' ? maxLossText : maxProfitText), gradient === 'loss' ? (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: "text.negative"
  }, maxLossWithSign) : (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: "text.positive"
  }, maxProfitWithSign)), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    padding: [0, 24]
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body"
  }, gradient === 'profit' ? maxProfitText : maxLossText), gradient === 'profit' ? (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: "text.positive"
  }, maxProfitWithSign) : (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: "text.negative"
  }, maxLossWithSign)), (0, _pragma.createFelaElement)(_.View, {
    css: css.chartBlock,
    flex: true,
    flexDirection: "column",
    cssProps: {
      gradient
    }
  }, isTwoBreakEvens ? (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.View, {
    css: css.breakEvenBlock,
    cssProps: {
      top: calculateTopPosition(24)
    },
    flexDirection: "column",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body",
    align: "center",
    color: "text.3"
  }, "".concat(breakEvenText, " 1")), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    align: "center",
    color: "text.3"
  }, breakEven[0])), (0, _pragma.createFelaElement)(_.View, {
    css: css.breakEvenBlock,
    cssProps: {
      top: calculateTopPosition(69)
    },
    flexDirection: "column",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body",
    align: "center",
    color: "text.3"
  }, "".concat(breakEvenText, " 2")), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    align: "center",
    color: "text.3"
  }, breakEven[1]))) : (0, _pragma.createFelaElement)(_.View, {
    css: css.oneBreakEvenBlock,
    cssProps: {
      top: breakEvenTop
    },
    flexDirection: "column",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body",
    align: "center",
    color: "text.3"
  }, breakEvenText), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    align: "center",
    color: "text.3"
  }, breakEven[0]))), chartStepsLength > 0 && (0, _pragma.createFelaElement)(_reactDraggable.default, {
    axis: "y",
    bounds: "parent",
    handle: "strong",
    grid: [diapason, diapason],
    onDrag: handleDrag
  }, (0, _pragma.createFelaElement)("div", {
    style: css.dragBlock({
      cssProps: {},
      theme
    })
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    alignItems: "flex-start",
    padding: [0, 24]
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body"
  }, takeHomeText), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: (0, _util.getPositiveOrNegativeColor)((0, _util.unformatValue)(chartSteps[currentItemIndex].payoff))
  }, addRupeeSign(chartSteps[currentItemIndex].payoff))), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    size: "body"
  }, scripName.toUpperCase()), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    size: "m",
    color: "text.default"
  }, chartSteps[currentItemIndex].spot)), (0, _pragma.createFelaElement)("br", null), (0, _pragma.createFelaElement)("strong", null, (0, _pragma.createFelaElement)(_.View, {
    css: css.dragIconBlock,
    justifyContent: "flex-end",
    padding: [0, 24]
  }, (0, _pragma.createFelaElement)(_.DragIcon, {
    size: "large",
    color: "icon2"
  }))))));
};

var _default = PnlAnaliticsChart;
exports.default = _default;
//# sourceMappingURL=PnlAnaliticsChart.js.map